/* Pixel height of the native bottom tab bar, excluding safe-area-inset.
 * Shared by Layout (bottom padding for content) and NativeSheet (so the
 * sheet sits just above the bar). */
export const NATIVE_TAB_BAR_HEIGHT = 65;
